import {Injectable} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmBimService} from '../../mm-bim.service';
import {BimModel, BimModelVersion} from '@mydocma/co/src/lib/common';
import {BehaviorSubject, Subject} from 'rxjs';

import {ViewerReadyParams} from '@mydocma/bim-viewer';
import {filter} from 'rxjs/operators';
import {PinService} from '../pin-service/pin-service';
import {BimModelAvailabilityService} from '../../bim-model-availability.service';
import {ExtendedBimModel} from "../../extended-bim-model";


@UntilDestroy()
@Injectable()
export class MmBimViewerService {
  private currentBimModelVersionSubject = new BehaviorSubject<BimModelVersion>(null);
  public currentBimModelVersion$ = this.currentBimModelVersionSubject.asObservable();

  private currentBimModelSubject = new BehaviorSubject<ExtendedBimModel>(null);
  public currentBimModel$ = this.currentBimModelSubject.asObservable();
  private bimViewerReadParamData: ViewerReadyParams;
  private bimModelReadySubject = new Subject<ViewerReadyParams>();
  public bimModelReady$ = this.bimModelReadySubject.asObservable();

  constructor(private mmBimService: MmBimService, private mmPinService: PinService,) {
    this.mmBimService.selectedBimModel$
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe(value => this.handleSelectedBimModel(value));
  }

  public onBimViewerReady($event: ViewerReadyParams): void {
    this.bimViewerReadParamData = $event;
    this.bimViewerReadParamData.viewerService.onModelLoaded$.pipe(untilDestroyed(this), filter(Boolean))
      .subscribe(value => {
        this.bimModelReadySubject.next($event);
      });
    $event.pinService.onPinSelectionChanged.pipe(untilDestroyed(this)).subscribe((selectionChange) => {
      this.mmPinService.selectPin(selectionChange.selection[0]);
    });

  }

  public handleSelectedBimModel(bimModel: ExtendedBimModel): void {
    const currentBimModelVersion = this.currentBimModelVersionSubject.value;
    if (bimModel && currentBimModelVersion?.bimModelId !== bimModel.id) {
      const activeVersions = bimModel.versions?.filter(x => x?.active);
      const activeVersion = activeVersions[activeVersions?.length - 1];
      this.currentBimModelSubject.next(bimModel);
      // (activeVersion as any)['subModels'] = bimModel.subModels;
      this.currentBimModelVersionSubject.next(activeVersion);
    }
  }

}
